import { api } from "../../http";

async function GetDataAllMaquinas() {
  try {
    
    const data = await api.get(`/maquina`);
    return data;


  } catch (e) {
    console.log(e.message);
  }
}

export { GetDataAllMaquinas };
